import { IconName } from '@fortawesome/fontawesome-svg-core';
import { IconPrefix } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    title?: string;
    titleAlign?: 'left' | 'center';
    titleIcon?: {
        iconPrefix: IconPrefix;
        iconName: IconName;
    };
    children?: React.ReactNode;
}

export const PageSection = (props: Props) => {
    return (
        <S_PageSection className={props.className}>
            {props.title && (
                <S_Header $align={props.titleAlign}>
                    <S_HeaderIcon icon={[props.titleIcon.iconPrefix, props.titleIcon.iconName]} />
                    <S_HeaderText>{props.title}</S_HeaderText>
                </S_Header>
            )}
            <S_Content>{props.children}</S_Content>
        </S_PageSection>
    );
};

const S_PageSection = styled.div`
    padding: 0px 0px;
    margin: 0 0 20px 0;
`;

const S_Header = styled.div<{ $align: Props['titleAlign'] }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${(props) => props.$align};
    margin-bottom: 20px;
`;

const S_HeaderIcon = styled(FontAwesomeIcon)`
    font-size: 16px;
    text-align: left;
    margin-right: 15px;
    color: #4a4a4a;
`;
const S_HeaderText = styled.div`
    color: #4a4a4a;
    font-size: 14px;
    font-family: ${EFonts.InterMedium};
`;

const S_Content = styled.div``;
